import { useState } from "react";
import {
  Alert,
  AlertIcon,
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useAuth } from "../../auth/hooks/useAuth";
import { useAcceptTermsMutation } from "../hooks/useAcceptTermsMutation";
import TermsConsentLabel from "./TermsConsentLabel";

// Pedido de aceite para quem ainda não aceitou a versão vigente dos termos: contas
// anteriores ao aceite obrigatório, contas criadas pelo login com Google e todo mundo
// quando os termos mudam. Não fecha (sem X, Esc ou clique fora) — a única saída além de
// aceitar é sair da conta.
export default function TermsAcceptanceModal() {
  const { user, logout, refetchMe } = useAuth();
  const [checked, setChecked] = useState(false);
  const acceptMutation = useAcceptTermsMutation();

  // `=== true` para não travar o app se a API ainda não devolver o campo (frontend novo
  // com backend antigo durante o deploy).
  if (user?.must_accept_terms !== true) {
    return null;
  }

  const onAccept = () => {
    acceptMutation.mutate(user.current_terms_version, {
      // 422 = os termos mudaram com a tela aberta: recarrega a versão vigente.
      onError: (error) => {
        if (error.response?.status === 422) refetchMe();
      },
    });
  };

  const erro = acceptMutation.error?.response?.data;

  return (
    <Modal isOpen onClose={() => {}} closeOnOverlayClick={false} closeOnEsc={false} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Termos de Uso e Política de Privacidade</ModalHeader>
        <ModalBody>
          <Stack spacing={4}>
            <Text fontSize="sm" color="app-muted-fg">
              {user.terms_version
                ? "Atualizamos nossos Termos de Uso e nossa Política de Privacidade. Para continuar usando o MedStation, leia e aceite a nova versão."
                : "Para continuar usando o MedStation, leia e aceite nossos Termos de Uso e nossa Política de Privacidade."}
            </Text>
            <Checkbox isChecked={checked} onChange={(e) => setChecked(e.target.checked)} alignItems="flex-start">
              <TermsConsentLabel />
            </Checkbox>
            {acceptMutation.isError ? (
              <Alert status="error" borderRadius="md" fontSize="sm">
                <AlertIcon />
                {erro?.erros?.[0]?.mensagem ?? erro?.mensagem ?? "Não foi possível registrar o aceite. Tente novamente."}
              </Alert>
            ) : null}
          </Stack>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={logout} isDisabled={acceptMutation.isPending}>
            Sair
          </Button>
          <Button onClick={onAccept} isDisabled={!checked} isLoading={acceptMutation.isPending}>
            Aceitar e continuar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
